




















import { defineComponent, PropType } from "@vue/composition-api";
import { Tab } from "@/types";
import { TabType } from "@/const";

export default defineComponent({
  name: "BaseSegmentedButton",
  props: {
    value: { required: true },
    tabs: { type: Array as PropType<Tab[]>, required: true },
    smallButton: { type: Boolean },
  },
  setup() {
    return { TabType };
  },
});
